<!-- <div mat-dialog-title>
    <div class='text-right line-height-0'>
        <button class="btnclose" [mat-dialog-close] tabindex="-1"></button>
    </div>
    <div class="col-12 popupTitle_rules p-0">
        <span class="col-12 p-0">{{title}}</span>
    </div>
</div> -->

<div mat-dialog-title class="mb-0">
    <div class='"col-6'>
        <button class="btnclose gtext-riht line-height-0 float-right mr-3" [mat-dialog-close] tabindex="-1"></button>
    </div>
    <div class="col-6 popupTitle_rules p-0 ml-3 mb-1">
        <span class="col-6 p-0">{{title}}</span>
    </div>
</div>


<mat-dialog-content>
    <div *ngIf='type === "view_history"'>
        <div class="history-div">
            <div class="col-12">
                <div class="checkBoxlign ">
                    <div class="table-responsive striped " [ngClass]="{'table-css':history?.length != 0 }">
                        <table class="col-12  users_mode" mat-table [dataSource]="history">
                            <ng-container matColumnDef="Date">
                                <th mat-header-cell class="small-column" *matHeaderCellDef>Date</th>
                                <td mat-cell *matCellDef="let element"> {{element['created'] | date : 'MMM dd, yyyy'}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Time">
                                <th mat-header-cell class="small-column" *matHeaderCellDef>Time</th>
                                <td mat-cell *matCellDef="let element"> {{element['created'] | date : 'hh:mm:ss a' }}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Description">
                                <th mat-header-cell *matHeaderCellDef> Description </th>
                                <td mat-cell *matCellDef="let element" class="sml-col"> {{element['description']}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Business">
                                <th mat-header-cell class="small-column" *matHeaderCellDef> Business </th>
                                <td mat-cell *matCellDef="let element">
                                    <div> {{element['actioned_business_name']}} </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Updated By">
                                <th mat-header-cell class="small-column" *matHeaderCellDef>Updated By</th>
                                <td mat-cell *matCellDef="let element"> {{element['createdby_fullname']}}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="businessHistoryColoumn"></tr>
                            <tr mat-row *matRowDef="let row; columns:businessHistoryColoumn;"></tr>
                        </table>
                    </div>
                    <div class="col-12 text-center p-2" *ngIf="history.length == 0">
                        No Data Found
                    </div>
                    <div class="col-12 bgWhite" *ngIf="history.length > 0">
                        <div class="row align-items-center ">
                            <div class="col-12">
                                <mat-paginator *ngIf="history?.length != 0"
                                    [pageSizeOptions]="page.pageSizeOptions" [length]="page.limit"
                                    [pageSize]="page.pageSize" (page)="historyPageChange($event, 'page')" [pageIndex]="page.index"
                                    showFirstLastButtons></mat-paginator>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>